import React from 'react';

const EnquirayPrescription = ({ prescription }) => {
    // Debug logs
    console.log("Full prescription data:", prescription);
    
    // Extract image URL from different possible paths
    let imageUrl = null;
    
    if (Array.isArray(prescription) && prescription.length > 0) {
        const firstItem = prescription[0];
        
        // Try multiple possible paths based on your API structure
        imageUrl = firstItem?.prescriptionId?.prescriptionImgUrl ||
                  firstItem?.prescriptionData?.prescriptionImgUrl ||
                  firstItem?.prescription?.prescriptionImgUrl ||
                  firstItem?.prescriptionImgUrl;
    }
    
    console.log("Prescription image URL:", imageUrl);

    return (
        <div className="w-full bg-[#F8F8F8] mt-3 p-4 rounded-[16px] border border-gray-100">
            <label className="block mb-3 font-semibold text-gray-700">
                Attached Prescription
            </label>
            
            <div className="flex justify-center bg-white p-2 rounded-lg border border-gray-200 overflow-hidden">
                {imageUrl ? (
                    <img 
                        className="w-full h-auto max-w-xs md:max-w-md lg:max-w-lg rounded-md shadow-sm object-contain" 
                        src={imageUrl} 
                        alt="Patient Prescription"
                        onError={(e) => { 
                            console.error("Failed to load prescription image:", imageUrl);
                            e.target.src = 'https://via.placeholder.com/400x200?text=Prescription+Image+Not+Available'; 
                        }}
                    />
                ) : (
                    <div className="py-10 text-center">
                        <div className="text-gray-400 text-sm italic">
                            No prescription attached
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default EnquirayPrescription;